module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_1.100208c2.woff2";